import { render, staticRenderFns } from "./defectEditDialog.vue?vue&type=template&id=a14630a4&scoped=true&"
import script from "./defectEditDialog.vue?vue&type=script&lang=js&"
export * from "./defectEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14630a4",
  null
  
)

export default component.exports